{
    "CustomNameLabel": "Nome:",
    "CustomWidthLabel": "Largura (0 - 100):",
    "CustomSettings_SectionHeader": "Definições personalizadas",
    "NAME": "CustomSettings"
}